import { render, staticRenderFns } from "./CondominiumFeesHousing.vue?vue&type=template&id=4615a2c6&scoped=true&"
import script from "./CondominiumFeesHousing.vue?vue&type=script&lang=js&"
export * from "./CondominiumFeesHousing.vue?vue&type=script&lang=js&"
import style0 from "./CondominiumFeesHousing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CondominiumFeesHousing.vue?vue&type=style&index=1&id=4615a2c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4615a2c6",
  null
  
)

export default component.exports